import {createContext, useContext} from "react";

import {EditorView} from "prosemirror-view";
import { EditorState } from 'prosemirror-state'


export const EditorViewContext = createContext<EditorView | null>(null)

export const useEditorView = (): EditorView | null => {
    return useContext(EditorViewContext);
}

export const EditorStateContext = createContext<EditorState | null>(null)

export const useEditorState = (): EditorState | null => {
    return useContext(EditorStateContext);
}